import { formatFechaRange, formatHoraHHMM } from "utils/formatters";

export const DEFAULT_ACTIVITY_COVER_URL =
  "https://images.unsplash.com/photo-1521412644187-c49fa049e84d?auto=format&fit=crop&w=1200&q=60";

export function normalizeActividadForCard(actividad) {
  return {
    id: actividad.id,
    nombre: actividad.nombre?.trim() || "Actividad sin nombre",
    desc: actividad.descripcion?.trim() || "Sin descripcion",
    fecha: formatFechaRange({ fechaInicio: actividad.fechaInicio, fechaFin: actividad.fechaFin }),
    horaInicio: formatHoraHHMM(actividad.horaInicio),
    horaFin: formatHoraHHMM(actividad.horaFin),
    foto: actividad.coverUrl || DEFAULT_ACTIVITY_COVER_URL,
    published: actividad.published !== false,
    isIncomplete: actividad.isIncomplete === true,
    socios: Number(actividad.asistenciaSociosCount ?? 0),
    instructores: Number(actividad.asistenciaInstructoresCount ?? 0),
    preceptorias: Number(actividad.preceptoriasCount ?? 0),
  };
}

export function compareActividadesForDisplay(a, b) {
  const aHasDate = !!a.fechaInicio;
  const bHasDate = !!b.fechaInicio;
  if (aHasDate !== bHasDate) return aHasDate ? -1 : 1;

  const aDateTime = `${a.fechaInicio ?? "0000-00-00"} ${a.horaInicio ?? "00:00"}`;
  const bDateTime = `${b.fechaInicio ?? "0000-00-00"} ${b.horaInicio ?? "00:00"}`;
  if (aDateTime !== bDateTime) return bDateTime.localeCompare(aDateTime);

  return String(b.createdAt ?? "").localeCompare(String(a.createdAt ?? ""));
}

